module.exports = __webpack_public_path__ + "img/6.9731ce37.jpg";